import styled from "styled-components/macro";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdImage,
  MdMenu,
  MdPauseCircleFilled,
  MdPlayCircleFilled,
} from "react-icons/md";
import React, { useEffect, useRef, useState } from "react";
import "../styles/Cart.css";
import Topnav from "../components/Topnav";
import { useNavigate, useParams } from "react-router";
import Footer from "../components/Footer";
import { formatEuroCents } from "../functions/formatEuroCents";
import { isEmpty } from "../functions/isEmpty";

export default function Cart({
  products,
  cart,
  setCart,
  reviews,
  isMobile,
  language,
  setLanguage,
  texts,
}) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [cart_value, setCart_value] = useState(0);
  const [summarized_cart, setSummarizedCart] = useState([]);

  useEffect(() => {
    const summaryMap = new Map();

    cart.forEach((product) => {
      const priceInCents = Number(product.price); // <-- sicherstellen, dass es eine Zahl ist

      if (summaryMap.has(product.id)) {
        const existing = summaryMap.get(product.id);
        existing.count += 1;
        existing.price_all += priceInCents; // Cent summieren
      } else {
        summaryMap.set(product.id, {
          id: product.id,
          name: product.name,
          price: priceInCents, // auch hier Zahl
          count: 1,
          price_all: priceInCents,
          images: product.images,
          description: product.description,
        });
      }
    });

    setSummarizedCart(Array.from(summaryMap.values()));
  }, [cart]);

  useEffect(() => {
    let count = 0;
    cart.forEach((cartItem) => {
      count += Number(cartItem.price); // <-- String -> Zahl
    });
    setCart_value(count);
  }, [cart]);

  function updateCart(productId, action, cart, setCart) {
    if (action === "increase") {
      // Finde das erste Produkt mit der passenden ID (wir nehmen es als Referenz zum Klonen)
      const productToAdd = cart.find((p) => p.id === productId);
      if (productToAdd) {
        setCart([...cart, { ...productToAdd }]);
      }
    } else if (action === "decrease") {
      // Letztes Vorkommen des Produkts finden
      const indexToRemove = [...cart].map((p) => p.id).lastIndexOf(productId);
      if (indexToRemove !== -1) {
        const newCart = [...cart];
        newCart.splice(indexToRemove, 1);
        setCart(newCart);
      }
    }
  }

  return (
    <div className="cart">
      <Topnav
        cart={cart}
        language={language}
        setLanguage={setLanguage}
        isMobile={isMobile}
      />
      <div className="home_banner">
        {" "}
        {language == "Deutsch" ? texts.de.banner : texts.en.banner}{" "}
      </div>
      <div className="cart_section">
        <div className="cart_section_summary">
          <div className="cart_section_summary_title">
            {language == "English" ? "Cart" : "Warenkorb"}
          </div>
          <div className="cart_section_summary_table">
            <div className="cart_section_summary_table_firstrow">
              <div className="cart_section_summary_table_firstrow_firstcol">
                Produkt
              </div>
              <div className="cart_section_summary_table_firstrow_secondcol">
                Anzahl
              </div>
              <div className="cart_section_summary_table_firstrow_thirdcol">
                Betrag
              </div>
            </div>
            {cart.length <= 0 ? (
              <div style={{ paddingLeft: 20 }}>Dein Warenkorb ist leer.</div>
            ) : (
              <>
                {summarized_cart.map((item, index) => (
                  <div className="cart_section_summary_table_productrow">
                    <div className="cart_section_summary_table_productrow_firstcol">
                      <div
                        className="cart_section_summary_table_productrow_firstcol_imgbox"
                        onClick={() => navigate("/product/" + item.id)}>
                        <img
                          src={JSON.parse(item.images)[0]}
                          className="cart_section_summary_table_productrow_firstcol_imgbox_img"
                        />
                      </div>
                      <div
                        className="cart_section_summary_table_productrow_firstcol_textbox"
                        onClick={() => navigate("/product/" + item.id)}>
                        <div className="cart_section_summary_table_productrow_firstcol_textbox_top">
                          {item.name}
                        </div>
                        <div className="cart_section_summary_table_productrow_firstcol_textbox_bottom">
                          {item.description}
                        </div>
                        {isMobile && (
                          <div className="mobile_count">
                            <div
                              className="cart_section_summary_table_productrow_secondcol_button"
                              onClick={() =>
                                updateCart(item.id, "decrease", cart, setCart)
                              }>
                              -
                            </div>
                            {item.count}
                            <div
                              className="cart_section_summary_table_productrow_secondcol_button"
                              onClick={() =>
                                updateCart(item.id, "increase", cart, setCart)
                              }>
                              +
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="cart_section_summary_table_productrow_secondcol">
                      {!isMobile && (
                        <>
                          <div
                            className="cart_section_summary_table_productrow_secondcol_button"
                            onClick={() =>
                              updateCart(item.id, "decrease", cart, setCart)
                            }>
                            -
                          </div>
                          {item.count}
                          <div
                            className="cart_section_summary_table_productrow_secondcol_button"
                            onClick={() =>
                              updateCart(item.id, "increase", cart, setCart)
                            }>
                            +
                          </div>
                        </>
                      )}
                    </div>
                    <div className="cart_section_summary_table_productrow_thirdcol">
                      {formatEuroCents(item.price_all)}
                    </div>
                  </div>
                ))}
              </>
            )}
            <div className="cart_section_summary_table_summaryrow">
              <div className="cart_section_summary_table_summaryrow_top">
                <div className="cart_section_summary_table_summaryrow_top_firstcol"></div>
                <div className="cart_section_summary_table_summaryrow_top_secondcol">
                  Versand
                </div>
                <div className="cart_section_summary_table_summaryrow_top_thirdcol">
                  kostenfrei
                </div>
              </div>
              <div className="cart_section_summary_table_summaryrow_top">
                <div className="cart_section_summary_table_summaryrow_top_firstcol"></div>
                <div className="cart_section_summary_table_summaryrow_top_secondcol">
                  Gesamtsumme
                </div>
                <div className="cart_section_summary_table_summaryrow_top_thirdcol">
                  {formatEuroCents(cart_value)}
                </div>
              </div>

              <div className="cart_section_summary_table_summaryrow_bottom">
                <div className="cart_section_summary_table_summaryrow_bottom_firstcol"></div>
                <div className="cart_section_summary_table_summaryrow_bottom_secondcol">
                  {isEmpty(cart) ? (
                    <div
                      className="cart_section_summary_table_summaryrow_bottom_secondcol_cta_disabled"
                      disabled={isEmpty(cart)}>
                      Warenkorb leer
                    </div>
                  ) : (
                    <div
                      className="cart_section_summary_table_summaryrow_bottom_secondcol_cta"
                      onClick={() => navigate("/checkout")}>
                      Zur Kasse
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer texts={texts} language={language} />
    </div>
  );
}
const PlayIcon = styled(MdPlayCircleFilled)`
  font-size: 90px;
  color: #ffffff;
  margin-left: -8px;
  margin-top: -12px;
`;

const PauseIcon = styled(MdPauseCircleFilled)`
  font-size: 90px;
  color: #ffffff;
  margin-left: -8px;
  margin-top: -12px;
`;

const ArrowBackIcon = styled(MdArrowBackIosNew)`
  font-size: 20px;
  color: #004a78;
`;
